import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { HowItWorks } from './pages/HowItWorks';
import { Pricing } from './pages/Pricing';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rkdxmv1kddoa">
      <Routes data-id="element-1" data-mp="2rlyq8f4bimji">
        <Route element={<Layout data-id="element-3" data-mp="2rit1j0zlpmob" />} data-id="element-2" data-mp="2rlf6qtz0rq3d">
          <Route path="/" element={<Home data-id="element-5" data-mp="2mmcb204xiw82" />} data-id="element-4" data-mp="2mlua4q7bnttt" />
          <Route path="/services" element={<Services data-id="element-7" data-mp="2mjpwhgjmfggc" />} data-id="element-6" data-mp="2mn5bykh7iria" />
          <Route path="/how-it-works" element={<HowItWorks data-id="element-9" data-mp="31brzh9gzmpkl" />} data-id="element-8" data-mp="31agn4l9h89hv" />
          <Route path="/pricing" element={<Pricing data-id="element-11" data-mp="2wk06yte9u9rt" />} data-id="element-10" data-mp="31c1iue7j1yhb" />
          <Route path="/about" element={<About data-id="element-13" data-mp="2wifgpfyzpczr" />} data-id="element-12" data-mp="2wjqg73lejyl2" />
          <Route path="/contact" element={<Contact data-id="element-15" data-mp="28tw62tsgwo4i" />} data-id="element-14" data-mp="2whxd1y9zzwht" />
        </Route>
      </Routes>
    </BrowserRouter>;
}